export default __webpack_public_path__ + "static/media/attach.94f5ba49.svg";